export const checkIsPending = (page) => page.status === 'unproposed'
export const checkIsCompleted = (proposal) => proposal.status === 'complete'

export const getLatestReaction = (reactions) => {
    const getLabel = (row) => {
        switch (row?.type) {
            case 'view':
                return '開封'
            case 'apply':
                return '応募したい'
            case 'keep':
                return 'キープしたい'
            case 'disregard':
                return '興味ない'
            default:
                return ''
        }
    }
    let unread = reactions.length ? true : false
    const row = [...reactions].reverse().find((reaction) => {
        if (reaction.type === 'CA_check') {
            unread = false
            return false
        }
        return true
    })
    if (row) {
        return {
            ...row,
            unread,
            label: getLabel(row),
        }
    }
}
